import TabPage from "./../factories/tab-page";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialog from "./../factories/bao-dialog";
import TranslateDialogViewModel from "./../factories/translate-dialog";
import BaseSearchPaging2 from "./../factories/search-paging2";

/**
 * ViewModel for WorkItemCategory
 */
class WorkItemCategory extends BaseSearchPaging2 {

    //#region Constructor

    /**
    * Constructor
    */
    public constructor(tabPage: TabPage) {
        super(tabPage);
        this.PermissionForward = "WorkItemCategoryForward";
        this.PermissionBackward = "WorkItemCategoryBackward";
    }

    //#endregion Constructor

    //#region Properties

    /**
    * Work Item Category Name 
    */
    WorkItemCategory: KnockoutComputed<any> = ko.pureComputed({
        read: () => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    return this.WorkItemCategory1();
                case 2:
                    return this.WorkItemCategory2();
                case 3:
                    return this.WorkItemCategory3();
                case 4:
                    return this.WorkItemCategory4();
                case 5:
                    return this.WorkItemCategory5();
            }
        },
        write: (value) => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    this.WorkItemCategory1(value);
                    break;
                case 2:
                    this.WorkItemCategory2(value);
                    break;
                case 3:
                    this.WorkItemCategory3(value);
                    break;
                case 4:
                    this.WorkItemCategory4(value);
                    break;
                case 5:
                    this.WorkItemCategory5(value);
                    break;
            }
        }
    });

    /**
    *  Primary Key
    */
    WorkItemCategoryId: KnockoutObservable<string> = ko.observable();

    /**
    *  Work Item Category Title in Deutsch language
    */
    WorkItemCategory1: KnockoutObservable<string> = ko.observable();

    /**
    * Work Item Category Title in English language 
    */
    WorkItemCategory2: KnockoutObservable<string> = ko.observable();

    /**
    * Work Item Category Title in fran�ais language
    */
    WorkItemCategory3: KnockoutObservable<string> = ko.observable();

    /**
    * Work Item Category Title in Romanian language 
    */
    WorkItemCategory4: KnockoutObservable<string> = ko.observable();

    /**
    * Work Item Category Title in Nederlands language 
    */
    WorkItemCategory5: KnockoutObservable<string> = ko.observable();

    /**
     * Work Item Category Client Route
     */
    ClientRoute: KnockoutObservable<string> = ko.observable();

    //#endregion Properties

    //#region Public Methods

    /**
    *  Validations
    */
    CompleteCheck = (): JQueryPromise<boolean> | boolean => {
        let completed: boolean;
        completed = true;
        if (Bao.Utils.String.IsNullOrWhitespace(this.WorkItemCategory())) {
            completed = false;
        }
        if (!completed) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return completed;
    }

    /**
     *  Init Url for Initialize page
     */
    public InitUrl(): string {
        return "WorkItemCategory/Init";
    }

    /**
     * Initialization 
     */
    init() {
        return $.when(super.init(), super.InitTabController(), Bao.Session.GetMessage("msgWorkItemTypeTabTitle")()).then(() => {
            const workItemCategoryWorkItemTypeTab = new TabPage('WorkItemCategoryWorkItemTypeTab');
            workItemCategoryWorkItemTypeTab.IsClosable(false);
            workItemCategoryWorkItemTypeTab.Url('WorkItemCategoryWorkItemTypeTab');
            workItemCategoryWorkItemTypeTab.Title(Bao.Session.GetMessage("msgWorkItemTypeTabTitle")());
            workItemCategoryWorkItemTypeTab.AutoSelect = true;
            this.TabController.AddTab(workItemCategoryWorkItemTypeTab);
        });
    }

    /**
     *Translate WorkItem Category Dialog
     */
    TranslateWorkItemCategory = (): void => {
        let translateDialog = new TranslateDialogViewModel(this.WorkItemCategory1, this.WorkItemCategory2, this.WorkItemCategory3, this.WorkItemCategory4, this.WorkItemCategory5);
        translateDialog.Open().then(() => {
        });
    }

    //#endregion Public Methods

}
export default WorkItemCategory;